import httpClient from './httpClient';


const isValidJSON = (data: any) => {
  try {
    JSON.parse(JSON.stringify(data));
  } catch (e) {
    return false;
  }
  return true;
};

const encodeFormData = (data: any) => { // TODO: add FormData type
  return Object.keys(data)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`)
    .join('&');
};

type Method = 'post' | 'get' | 'put' | 'patch' | 'delete'

interface RequestParams {
  method?: Method;
  url: string;
  payload?: any;
  config?: any; // TODO: add type
}

/**
 * Returns data if status >= 200 && status < 300. Throws error otherwize.
 * Error handling is being done using separate util (utils/errorHandling.ts)
 */
const request =  async ({ method = 'get', url, payload, config = {} }: RequestParams ) => {
  const requestParams = {
    method,
    ...config,
  };

  if (payload) {
    if (isValidJSON(payload) && !(payload instanceof FormData)) {
      if (config.headers && config.headers['Content-type'] === 'application/x-www-form-urlencoded') {
        requestParams.data = encodeFormData(payload);

        requestParams.headers = {
          ...requestParams.headers,
          ...config.headers,
        };
      } else {
        requestParams.data = payload;

        requestParams.headers = {
          ...requestParams.headers,
          'Content-Type': 'application/json',
        };
      }
    } else if (payload instanceof FormData) {
      requestParams.data = payload;
    }
  }
  const response = await httpClient(url, requestParams);
  return response;
};


export default request;


